import ColVisibilitySelector from "components/DataTable/ColVisibilitySelector"
import ItemActionsMenu from "components/DataTable/ItemActionsMenu"
import React from "react"
import Checkbox from "components/Checkbox/Checkbox";
import moment from 'moment';
import Button from "components/Button/Button";
import { getStatusButtonColor } from "helpers/utils";

export default {
    TABLE: {
        className: "data-table-remediation",
        initialSortKey: "start_date",
        initialSortOrder: "asc"
    },

    COLUMN: [
        {
            label: "Row Selector",
            key: "row-selector",
            header: ({ customTableProps }) => {
                const isSelectedAll =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.rowsData &&
                    customTableProps.rowsData.length &&
                    customTableProps.selectedRows.length ===
                        customTableProps.rowsData.length
                        ? true
                        : false
                return (
                    <Checkbox
                        checked={isSelectedAll}
                        onChange={() => customTableProps.doSelectAll()}
                        name="row-selector"
                    />
                )
            },
            className: "col-row-selector",
            format: ({ rowData, customTableProps }) => {
                const isSelected =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.selectedRows.some((checkbox) => {
                        return checkbox.id === rowData.id;
                    })
                        ? true
                        : false
                return (
                    <Checkbox
                        checked={isSelected}
                        onChange={() => customTableProps.onRowSelect({ rowData })}
                        name="row-selector"
                    />
                )
            }
        },
        // {
        //     label: "Id",
        //     header: "ID",
        //     key: "id",
        //     sortable: true,
        //     className: "id",
        //     format: ({ rowData, customTableProps }) => {
        //         return <span>{rowData["id"]}</span>
        //     }
        // },
        {
            label: "Title",
            header: "TITLE",
            key: "title",
            sortable: true,
            className: "remediation_title",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["title"]}</span>
            }
        },
        {
            label: "Regulatory",
            header: "REGULATORY",
            key: "regulatory_act",
            sortable: true,
            className: "type",
            format: ({ rowData }) => {
                return <span>{rowData["regulatory_act"]}</span>;
            }
        },
        {
            label: "Start Date",
            header: "START DATE",
            key: "start_date",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span>{rowData.start_date ? moment(rowData.start_date).format('MM/DD/YYYY') : ''}</span>;
            }
        },
        {
            label: "End Date",
            header: "END DATE",
            key: "end_date",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span>{rowData.end_date ? moment(rowData.end_date).format('MM/DD/YYYY') : ''}</span>;
            }
        },
        {
            label: "Open Tasks",
            header: "OPEN TASKS",
            key: "open_tasks",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span>{rowData.open_tasks}</span>
            }
        },
        {
            label: "Site",
            header: "SITE",
            key: "site",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData.siteName}</span>
            }
        },
        {
            label: "Status",
            header: "STATUS",
            key: "status",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                const status = rowData.status;
                const color = getStatusButtonColor(status, ["Complete"], ["Incomplete"]);
                return <span><Button cursorDefault={customTableProps.cursorDefault} color={color} size="md" icon={rowData.locked === "t" ? "fas fa-lock" : false} text={status} onClick={() => null} /></span>;
            }
        },
        {
            label: "Actions",
            key: "actions",
            format: ({ rowData, customTableProps }) => {
                const actionMenuDropDown = React.createRef();
                return (
                    <ItemActionsMenu
                        ref={actionMenuDropDown}
                        actions={(() => {
                            return [
                                customTableProps.notify ? {
                                    label: "Notify",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.notify(rowData)
                                    }
                                } : false,
                                customTableProps.complete ? {
                                    label: "Mark Complete",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.complete(rowData);
                                    }
                                } : false,
                                customTableProps.incomplete ? {
                                    label: "Mark Incomplete",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.incomplete(rowData);
                                    }
                                } : false,
                                customTableProps.delete ? {
                                    label: "Delete",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.delete(rowData);
                                    }
                                } : false,
                            ]
                        })()}
                    />
                )
            },
            className: "col-actions",
            header: ({ customTableProps }) => {
                return (
                    <ColVisibilitySelector
                        colDefs={customTableProps.colDefs}
                        visibleColumnKeys={customTableProps.visibleColumnKeys}
                        onChangeVisibility={colKey =>
                            customTableProps.onChangeVisibility(colKey)
                        }
                    />
                )
            }
        }
    ]
}
